export default __webpack_public_path__ + "static/media/icon_error.52523d8f.svg";